import { apiFetch } from '../../shared/api/httpClient';

export type MaintenanceLevel = 'normal' | 'game_only' | 'wallet_only' | 'full' | string;

export type MaintenanceStatus = {
  level?: MaintenanceLevel;
  message_i18n?: Record<string, string>;
  messageI18n?: Record<string, string>;
  scheduled_end?: number;
  scheduledEnd?: number;
  updated_at?: number;
  updatedAt?: number;
};

export function fetchMaintenance() {
  return apiFetch<MaintenanceStatus>('/api/maintenance', { cache: 'no-store' });
}
